module.exports = __webpack_public_path__ + "img/black_eyed_peas-nouvel_album.54b54245.jpg";